export default __webpack_public_path__ + "static/media/Deacon's Gloves of the Abyss.05ffd4da.jpg";